import { memoize } from 'lodash';

type GetNotificationTypeFromTypename = {
  substringToRemove: string;
  typename: string | undefined;
};

/**
 * @description `getNotificationTypeForTracking` - FOR TRACKING ONLY. A
 * function to retrieve a notification type based on a related typename. For
 * example, notifications settings have a custom
 * `NotificationTypeSettingReplyCreated` type. This function will extract the
 * corresponding notification type: `reply_created`.
 *
 * @param {string} substringToRemove - the substring to remove from the
 * `typename` param (e.g. `NotificationTypeSetting`)
 * @param {string} typename - the `typename` to infer the notification type from
 * (e.g. `NotificationTypeSettingReplyCreated`)
 *
 * @returns {null | string}
 **/
export const getNotificationTypeForTracking = memoize(
  ({ substringToRemove, typename }: GetNotificationTypeFromTypename) => {
    if (!typename) return null;

    /** e.g `NotificationGroupUserMentioned` becomes `UserMentioned` */
    const trimmedTypename = typename.replace(substringToRemove, '');

    const pascalCaseRegex = /(?=[A-Z])/;

    /** e.g `UserMentioned` becomes `user_mentioned` */
    const notificationType = trimmedTypename
      .split(pascalCaseRegex)
      .map((string) => string.toLowerCase())
      .join('_');

    return notificationType;
  },
  (...args) => JSON.stringify(args)
);
